import { CountriesService } from 'src/app/navigation/services/countries-service';
import { PackagingCollectiveQuantityDto, PackagingSystemQuantityDto, PackagingUnitQuantityDto, PackagingQuantity } from '../../../data-transfer/entities/packaging-unit-entities/packaging-quantity-dto';
import { Component, Inject } from '@angular/core';
import { MomentLocaleUtil } from 'src/app/util/moment-locale-util';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class MappedPackagingQuantityDto extends PackagingQuantity {
  packagingId: number | undefined;
  countryName = '';
  date = '';
}

@Component({
  selector: 'app-aggregated-quantities-dialog',
  templateUrl: './aggregated-quantities-dialog.component.html',
  styleUrls: ['./aggregated-quantities-dialog.component.scss']
})
export class AggregatedQuantitiesDialogComponent {

  packagingSystemQuantities: MappedPackagingQuantityDto[];
  packagingUnitQuantities: MappedPackagingQuantityDto[];

  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: PackagingCollectiveQuantityDto,
    private dialogRef: MatDialogRef<AggregatedQuantitiesDialogComponent>,
    private countriesService: CountriesService
  ) {
    this.packagingSystemQuantities = [];
    this.packagingUnitQuantities = [];
    dialogData.packagingSystemQuantities.forEach(x => this.packagingSystemQuantities.push(this.mapQuantity(x, x.packagingSystemId)));
    dialogData.packagingUnitQuantities.forEach(x => this.packagingUnitQuantities.push(this.mapQuantity(x, x.packagingUnitId)));
  }

  private mapQuantity(quantity: PackagingSystemQuantityDto | PackagingUnitQuantityDto, packagingId?: number): MappedPackagingQuantityDto {
    return {
      packagingId: packagingId,
      country: quantity.country,
      countryName: this.countriesService.getCountryNameByCode(quantity.country),
      month: quantity.month,
      year: quantity.year,
      date: MomentLocaleUtil.getTranslatedMonthYear(quantity.year, quantity.month - 1),
      quantity: quantity.quantity
    };
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
